<!-- 抖音退款新规更新提示 -->
<template>
    <div class="refund-change-tip-wrap">
        <!-- 【抖音新规-2024年6月1日起，退款和结算规则更新】点击查看 -->
        受抖音政策调整影响，9月3日以后的订单结算周期全部延长至履约后14天。
    </div>
</template>

<script>
    export default {
        data(){
            return {

            }
        },
        methods: {
            goLink(){
                let url = 'https://doutuimao.feishu.cn/wiki/BcDcwBz72imzgKk2VJ6cvSbgnkh?from=from_copylink'
                window.open(url)
            }
        }
    }
</script>

<style lang="less" scoped>
.refund-change-tip-wrap{
    color: red;
    // cursor: pointer;
    font-size: 14px;
    display: inline-block;
}
</style>